module.exports = __webpack_public_path__ + "static/media/IMG_20191204_133054.5a27e8d3.jpg";